import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '品类导航',
    links: [
      { label: '国产美妆', href: '/category?tab=meizhuang' },
      { label: '国产数码', href: '/category?tab=shuma' },
      { label: '国产食品', href: '/category?tab=shipin' },
      { label: '国产服饰', href: '/category?tab=fushi' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系方式', href: '/about#contact' },
      { label: '口碑评价', href: '/about#testimonials' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', href: '/#faq' },
      { label: '文章推荐', href: '/category' },
      { label: '品牌列表', href: '/#brands' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-300/60" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="text-xl font-heading font-bold text-foreground-900 whitespace-nowrap">
              国产专区
            </span>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              优质国货精选推荐平台，让更多人发现国货之美，支持中国品牌走向世界。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-3">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 国产专区 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}